export default {
  title: '{{company}} ți-a actualizat ora de ridicare',
  new_time_label: 'Ora nouă',
};
